export default function handleColorStyle(
  asBackgroundDegrade,
  isTextBlackOnly,
  styles
) {
  switch (asBackgroundDegrade) {
    case true:
      return styles._color_lightblue;
    case false:
    default:
      switch (isTextBlackOnly) {
        case false:
          return styles._color_black_blue;
        case true:
        default:
          return styles._color_black;
      }
  }
}
